import { User } from '../@types';
import { axiosInstance } from '../utils';

interface CreateUserPayload {
  name: string;
  email: string;
}

export const createUser = async (payload: CreateUserPayload): Promise<User> => {
  const res = await axiosInstance.post('/api/users', payload);
  return res.data;
};
